import moment from 'moment';
import { mapGetters } from 'vuex';

import { ChannelTextWrapper, Td, ItemWrapper } from './styles';
import { isValueExist, useReactState } from '@/utils/utils';
import ClickToCopyAssetId from '@/components/Dashboard/common/ClickToCopyAssetId.vue';

export const ErrorSourceRow = {
    name: 'ErrorSourceRow',
    setup() {
        const [showTooltip, setShowTooltip] = useReactState(true);
        return {
            showTooltip,
            setShowTooltip,
        };
    },
    props: {
        rowSize: {
            type: Number,
        },
        connectorType: {
            type: String,
        },
        showConnectorType: {
            type: Boolean,
        },
        name: {
            type: String,
        },
        disableAt: {
            type: String,
            default: '',
        },
        sourceId: {
            type: String,
            default: '',
        },
        logoUrl: {
            type: String,
        },
        lastErrorSource: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    computed: {
        ...mapGetters('user', ['isQa']),
    },
    render() {
        const lastSourceId = this.sourceId?.substring(
            this.sourceId.lastIndexOf('/') + 1
        );
        console.log({ errorSource: this.lastErrorSource });
        const dataSource = this.lastErrorSource?.properties?.dataSource;
        const elasticUrl = `https://adriel.kb.ap-northeast-2.aws.elastic-cloud.com:9243/app/apm/services?comparisonEnabled=false&environment=ENVIRONMENT_ALL&rangeFrom=now-8h&rangeTo=now&offset=1d&kuery=${this.lastErrorSource?.traceId}`;

        return (
            <ItemWrapper>
                {this.connectorType && (
                    <Td>
                        {`${this.$t(
                            'WIDGET.error_panel.table.columns.channel'
                        )}: ${this.connectorType}`}
                    </Td>
                )}
                {(this.name || lastSourceId) && (
                    <Td>
                        {`${this.$t(
                            'WIDGET.error_panel.table.columns.name'
                        )}: ${this.name ?? lastSourceId}`}
                    </Td>
                )}
                {this.sourceId && (
                    <Td>
                        {`${this.$t('WIDGET.error_panel.table.columns.id')}: ${
                            this.sourceId
                        }`}
                    </Td>
                )}
                {/* {this.wrapTooltip({
                        visible: true,
                        title: this.sourceId,
                        content: this.sourceId,
                    })} */}
                {this.isQa && (
                    <div>
                        <Td>Error code: {this.lastErrorSource?.code}</Td>
                        <Td>
                            <ClickToCopyAssetId assetId={dataSource?.assetId} />
                        </Td>
                        <Td>Trace Id: {this.lastErrorSource?.traceId}</Td>
                        <Td>
                            Transaction Id:{' '}
                            {this.lastErrorSource?.transactionId}
                        </Td>
                        <Td>
                            <a href={elasticUrl} target="_blank">
                                Link to Elastic APM
                            </a>
                        </Td>
                    </div>
                )}
                {/*
                    this.globalUser?.meta?.showErrorCode && (
                        <Td>
                            <a href={""} target="_blank">
                                Link to Elastic APM
                            </a>
                        </Td>
                    )*/}
                {isValueExist(this.disableAt) && (
                    <Td>
                        {this.$t('WIDGET.error_panel.table.columns.disable_at')}
                        : {moment(this.disableAt).format('YYYY-MM-DD')}
                    </Td>
                )}
            </ItemWrapper>
        );
    },
};
